import { Box } from "../Box";
import { Typography } from "@mui/material";
import { createStyles, palette } from "../../../styles/theme";
import { getConditionnalStyle } from "../../../utils/themeUtils";

const styles = createStyles({
  container: {
    display: "flex",
    alignItems: "center",
    padding: "4px 8px",
    borderRadius: "100px",
    fontSize: "10px",
    cursor: "pointer",
  },
  active: {
    background: palette.brand.pale,
    "& > span": {
      color: palette.brand.secondary,
      fontWeight: "bold",
    },
  },
  inactive: {
    color: palette.grey.primary,
  },
});

interface Props {
  label: string;
  active?: boolean;
  onClick?: () => void;
}

const Chip = ({ label, active, onClick }: Props) => {
  return (
    <Box
      onClick={onClick}
      sx={[
        styles.container,
        getConditionnalStyle(active, styles.active),
        getConditionnalStyle(!active, styles.inactive),
      ]}
    >
      <Typography variant="textXs">{label}</Typography>
    </Box>
  );
};

export default Chip;
